const FooterNav = () => {
  const selectors = {
    section: ".footer-tgy",
    item: ".js-footer-nav-item",
    toggle: ".js-footer-nav-toggle"
  };

  function init(sectionId) {
    const sections = [...document.querySelectorAll(selectors.section)].filter(
      (el) => !sectionId || el.closest(`#shopify-section-${sectionId}`)
    );

    sections.forEach((section) => {
      section.querySelectorAll(selectors.item).forEach((item) => {
        const toggle = item.querySelector(selectors.toggle);
        if (!toggle || toggle.dataset.bound) return;
        toggle.dataset.bound = "true";

        toggle.addEventListener("click", () => {
          const isOpen = item.classList.toggle("is-open");
          toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        });
      });
    });
  }

  return Object.freeze({ init });
};

const action = () => {
  window.themeCore.FooterNav = window.themeCore.FooterNav || FooterNav();
  window.themeCore.utils.register(window.themeCore.FooterNav, "footer-nav");
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
